import React from 'react'
import { ListItemText, Tooltip, Typography } from '@mui/material'
import { StyledListItemButton, StyledListItemIcon } from '../../styles/SidebarStyles'
import { useAppSelector } from '../../store/redux/hooks'
import { Circle } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

type SidebarLinkProps = {
  open: boolean
  Icon: React.ElementType
  text: string
  index: number | number[]
  route?: string
  action?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  standard?: boolean
  isCollapsing?: boolean
} & Omit<React.ComponentProps<typeof StyledListItemButton>, 'children' | 'ref' | 'open' | 'collapsing'>

const SidebarLink = React.forwardRef<HTMLDivElement, SidebarLinkProps>(
  ({ open, Icon, text, route, action, index, standard, isCollapsing, ...buttonProps }, ref) => {
    const { onClick: externalOnClick, ...restButtonProps } = buttonProps
    const pageIndex = useAppSelector(state => state.pageName.index)
    const isSelected = Array.isArray(index) ? index.includes(pageIndex) : index === pageIndex
    const navigate = useNavigate()

    const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      externalOnClick?.(event)
      if (event.defaultPrevented) {
        return
      }
      if (action) {
        action(event)
        return
      }
      if (route) {
        navigate(route)
      }
    }

    return (
      <Tooltip title={open ? '' : text} placement="right">
        <StyledListItemButton
          {...restButtonProps}
          collapsing={isCollapsing}
          open={open}
          ref={ref}
          dense
          sx={{
            ml: 0,
            width: open ? '191px' : 20,
            pl: !standard ? 1 : 'auto',
          }}
          selected={isSelected}
          onClick={handleClick}
        >
          <StyledListItemIcon sx={{ opacity: index === pageIndex || standard ? 1 : 0, width: 18 }}>
            {standard ? <Icon sx={{ width: standard ? 18 : 9 }} /> : <Circle sx={{ width: 9 }} />}
          </StyledListItemIcon>

          <ListItemText sx={{ visibility: open ? 'visible' : 'hidden' }}>
            <Typography variant="body2" fontSize={12} fontWeight={400} ml={1} noWrap>
              {text}
            </Typography>
          </ListItemText>
        </StyledListItemButton>
      </Tooltip>
    )
  }
)

export default SidebarLink
